import './styles/global.css';
import './styles/dark-theme.css';

export { AddComment } from './containers/AddComment';
export { CommentList } from './containers/CommentList';
export { ThemeToggle } from './components/ThemeToggle';
export { hasUnreadMentionsForUser } from './hooks/menu/useCommentMenu';
export { useLocalTimestamp } from './hooks/timestamp/useLocalTimestamp';
export {
  useGetCommentInitialPageStart,
  type UseGetCommentInitialPageStartOptions,
  type GetCommentInitialPageStartResult
} from './hooks/useGetCommentInitialPageStart';
export type {
  Comment,
  CommentMention,
  EditParams,
  ReplyParams,
  IconOverrides
} from './containers/CommentList/CommentList.types';
export type { CommentSubmissionData } from './containers/CommentForm';
export type { MenuOption } from './components/OptionsMenu/OptionsMenu.types';
export type { ThemeToggleProps, Theme } from './components/ThemeToggle';
